export const locale = {
  common_error: 'An error occurred while processing your request.',
};
